import Button from 'bee-button'

export default Button
